import { render } from "./MobileRedirect.vue?vue&type=template&id=df233bdc&scoped=true"
import script from "./MobileRedirect.vue?vue&type=script&lang=js"
export * from "./MobileRedirect.vue?vue&type=script&lang=js"

import "./MobileRedirect.vue?vue&type=style&index=0&id=df233bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df233bdc"]])

export default __exports__